export default "__VITE_ASSET__4f09d5ab__"